import React, { PureComponent } from 'react'
import { string, func, arrayOf, shape } from 'prop-types'

import { SelectorButton } from 'components'
import './SectionSelectors.css'

export class SectionSelectors extends PureComponent {
    static propTypes = {
        selectors: arrayOf(
            shape({
                id: string.isRequired,
                icon: string.isRequired,
                label: string.isRequired
            })
        ).isRequired,
        selected: string,
        onSelect: func
    }

    renderSelector = ({ id, icon, label }) => {
        const { selected, onSelect } = this.props
        const isSelected = selected === id
        return <SelectorButton key={id} id={id} icon={icon} label={label} selected={isSelected} initial={!selected} onClick={isSelected ? null : () => onSelect(id)} />
    }

    render() {
        const { id, selectors } = this.props
        return (
            <section id={id} className="Selectors">
                <div className="flex row-stretch-top">{selectors.map(this.renderSelector)}</div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Sections/Selectors/SectionSelectors.js